import script from "./HomePageAverageProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePageAverageProgress.vue?vue&type=script&setup=true&lang=js"

import "./HomePageAverageProgress.vue?vue&type=style&index=0&id=b153e1b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b153e1b8"]])

export default __exports__